import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>We may not like to think that something like physical
                                                attractiveness affects our judgement.
                                                However, the reality is that it is likely to have at some
                                                point. This tool is about <span className="green brownbold">how to make reasoned judgements</span> and
                                                aims to help you make decisions more effectively. The tool
                                                guides you
                                                in developing your judgement-forming skills and applying
                                                them in a range of situations.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>WHY IS REASONED JUDGEMENT IMPORTANT?
                                            </div>
                                            <p>Reasoned judgement is the process of using all of the
                                                available information to weigh the pros
                                                and cons of a number of alternative options, leading to a
                                                selected course of action.</p>
                                            <p>All reasoned judgements should lead to a final choice. The
                                                process begins when we are first
                                                aware of the need to take action but are unsure of the best
                                                choice. We therefore start the
                                                process of reasoned judgement, which is based on both
                                                explicit and implicit assumptions.</p>

                                            <p>Reasoned judgement involves a process and an output. This
                                                means that part of reasoned judgement
                                                will involve a thinking process and part will involve
                                                actions that are observable by others. Based on
                                                observable actions, we assume that a person has made a
                                                commitment to effect the action. </p>
                                            <p>Reasoned judgement plays an important part in many
                                                professions, where specialists are required
                                                to apply their knowledge to make informed decisions.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>A MODEL OF REASONED JUDGEMENT MAKING
                                            </div>
                                            <p>When you demonstrate effective judgement, you are doing no
                                                more than making rational, realistic
                                                and sound decisions based on consideration of all the facts
                                                and alternatives available. The model
                                                below shows a series of stages we go through when making
                                                reasoned judgements.</p>


                                            <div className="challeng-bg text-center pt-4">
                                                <p align="left"><span className="subtiltereg sept">Model of Rational Judgement<a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300"><sup>6</sup></a></span>
                                                </p>
                                                <img
                                                    src={require('@images/reasoned-judgement2.png')}
                                                    alt="image"/></div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}